import { DOCK_HOURS_OPTIONS, prettyDockHours } from '@pelicargo/utils';

import { SimpleSelect } from './SimpleSelect';
import { SimplePopoverUnifiedInput } from './SimpleUnifiedPopoverInput';

export const SimpleLabeledPopoverDockHoursInput = ({
  fromName = 'from_dock_hours',
  toName = 'to_dock_hours',
}: {
  fromName?: string;
  toName?: string;
}) => {
  return (
    <SimplePopoverUnifiedInput
      flex={1}
      label="Dock Hours"
      names={[fromName, toName]}
      formatDisplayValue={(values) => {
        if (!values[0] || !values[1]) return '-';
        return prettyDockHours(Number(values[0]), Number(values[1]));
      }}
      tabIndex={0}
      isHorizontal
    >
      <SimpleSelect name={fromName} label="From" options={DOCK_HOURS_OPTIONS} variant="outline" />
      <SimpleSelect name={toName} label="To" options={DOCK_HOURS_OPTIONS} variant="outline" />
    </SimplePopoverUnifiedInput>
  );
};
